import { render, staticRenderFns } from "./ed-create-school-day.component.vue?vue&type=template&id=0c50eb16&scoped=true&"
import script from "./ed-create-school-day.component.ts?vue&type=script&lang=ts&"
export * from "./ed-create-school-day.component.ts?vue&type=script&lang=ts&"
import style0 from "./ed-create-school-day.component.scss?vue&type=style&index=0&id=0c50eb16&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c50eb16",
  null
  
)

export default component.exports